<template>
    <div class='country-select-spinner' :class="{disabled}">
        <!-- <p class="input-clue">{{$t('countrySelectSpinner.chooseClue')}}</p> -->
        <div class="spinner-container" ref="spinnerContainer" @click.stop>
            <div class="result-box" :class="{active: showPop, error: required}" @click="togglePop">
                <input class="result-input"
                    type="text"
                    @change="handleAutoFill"
                    :value="selectedCountryText"
                    :placeholder="placeholder"
                    autocomplete="country-name">
                <span v-show="selectedCountryText !== ''" class="top-placeholder">{{ $t( 'countrySelectSpinner.placeholder' ) }}</span>
                <span class="arrow-icon icon-icon_arrow-down" v-if="!disabled"></span>
                <span class="required-icon">*</span>
            </div>
            <div class="drop-down-box" v-show="showPop">
                <div class="input-box">
                    <input type="text" v-model="searchText" @keyup.enter="inputEnter">
                    <span class="icon-icon_search-2"></span>
                </div>
                <ul class="country-list">
                    <li class="no-match" v-show="filteredCountryList.length===0">
                        {{$t('countrySelectSpinner.notAvailable1')}}
                        <a @click="showSubscription=true" class="notify-btn">{{$t('countrySelectSpinner.getNotified')}}</a>{{$t('countrySelectSpinner.notAvailable2')}}
                    </li>
                    <li class="country-item"
                        :class="{ active: item.code === selectedCountry }"
                        v-for="(item, index) in filteredCountryList"
                        :key="index"
                        @click="$emit('countrySelect',item.code); showPop = false;">
                        <!-- <img :src="item.image" > -->
                        <span>{{item.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <p class="spinner-clue" v-show="selectedCountry&&shippingAddressCountry!==selectedCountry&&!isTraffic">
            {{$t('countrySelectSpinner.differentClue')}}<br/>
            {{$t('countrySelectSpinner.differentClueNote')}}
        </p>
        <p class="spinner-clue" v-show="selectedCountry&&shippingAddressCountry!==selectedCountry&&isTraffic">
            {{$t('countrySelectSpinner.traffic.differentClue')}}<br/>
            {{$t('countrySelectSpinner.traffic.differentClueNote')}}
        </p>
        <reo-dialog
            class='email-subscribe'
            @cancel="showSubscription = false"
            :showButton=false
            v-if="showSubscription">
            <email-subscription subject="cloud-other-countries-ready" :is-traffic="isTraffic"></email-subscription>
        </reo-dialog>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import emailSubscription from '@/components/emailSubscription.vue';
import reoDialog from '@/basic/Dialog.vue';

export default Vue.extend({

    name: 'countrySelectSpinner',
    components: {

        emailSubscription,
        reoDialog

    },
    props: {
        selected: Object,
        error: Boolean,
        supportedCountryList: Array as PropType<any[]>,
        isTraffic: {
            type: Boolean,
            default: false
        },
        selectedCountry: {
            type: String
        },
        disabled: Boolean
    },
    created() {

        this.renderStateText();

    },
    data () {

        return {

            searchText: '',
            showPop: false,
            placeholder: this.$tc( 'countrySelectSpinner.placeholder' ),
            showSubscription: false,
            selectedState: '',
            selectedCountryText: '',
            required: false

        };

    },
    computed: {

        filteredCountryList (): any[] {

            if ( !this.searchText ) {

                return this.supportedCountryList.slice();

            }

            const text = this.searchText.toLowerCase();

            return this.supportedCountryList.filter( item => item.text.toLowerCase().includes( text ));

        },

        shippingAddressCountry (): string {

            return this.$store.getters.country;

        },

    },
    watch: {

        showPop ( n ) {

            if ( n ) {

                document.addEventListener( 'click', this.clickListener );

            } else {

                this.searchText = '';
                document.removeEventListener( 'click', this.clickListener );

            }

        },

        selectedCountry () {

            this.renderStateText();

        },

        error () {

            this.required = this.error;

        },

    },
    methods: {
        renderStateText(): void {

            let target = this.supportedCountryList.filter( item => item.code === this.selectedCountry )[0];
            if ( target ) {

                this.selectedCountryText = target.text;

            } else {

                this.selectedCountryText = '';
                this.$emit( 'countrySelect', '' );

            }

        },

        clickListener (): void {

            this.showPop = false;

        },
        inputEnter (): void {

            if ( !this.filteredCountryList[0] ) {

                return;

            }

            this.$emit( 'countrySelect', this.filteredCountryList[0].text );
            this.showPop = false;

        },
        togglePop (): void {

            this.showPop = !this.showPop;
            this.$emit( 'cancelErr' );

        },
        handleAutoFill( e: Event ): void {

            const targe = ( e.target as HTMLInputElement );
            if ( this.disabled ) {

                targe.value = this.supportedCountryList?.find( supportedCountry => supportedCountry.code === this.selectedCountry )?.text || '';
                return;
            
            }
            const fillCountry = targe?.value;

            const fillCountryItem = this.supportedCountryList.find( supportedCountry => supportedCountry.code === fillCountry || supportedCountry.text === fillCountry );
            if ( fillCountryItem ) {

                this.$emit( 'countrySelect', fillCountryItem.code );

            } else {

                ( e.target as HTMLInputElement ).value = '';
                this.$emit( 'countrySelect', '' );

            }

        }

    }

});
</script>

<style lang='less' scoped>
.country-select-spinner {
    margin-bottom: 20px;
    font-size: 16px;
    text-align: left;
    position: relative;
    z-index: 2;
    @media @snapeak_mobile {
        margin-bottom: 0.3rem;
        font-size: 0.28rem;
    }
    input {
        width: 100%;
        outline-offset: 0;
        border: none;
        font-size: 16px;
        font-weight: 500;
        padding: 0;
        box-sizing: border-box;
        &::placeholder{
            color: @font_primary;
        }
        @media @snapeak_mobile {
            font-size: 0.28rem;
        }
    }
    .input-clue {
        margin-bottom: 20px;
        @media @snapeak_mobile {
            margin-bottom: 0.3rem;
        }
    }
    .spinner-container {
        position: relative;
        z-index: 4;
        .result-box {
            display: flex;
            align-items: center;
            border: 1px solid transparent;
            box-shadow: 0 0 6px 2px rgba(0,0,0,.14);
            border-radius: 8px;
            padding-left: 20px;
            padding-right: 20px;
            position: relative;
            box-sizing: border-box;
            cursor: pointer;
            @media @snapeak_mobile {
                padding-left: 0.4rem;
                padding-right: 0.32rem;
            }
            .top-placeholder {
                position: absolute;
                left: 20px;
                top: 0;
                font-size: 14px;
                background-color: @bg_02;
                color: @b_6;
                font-weight: 500;
                transform: translateY(-50%);
                padding: 0 4px;
                @media @snapeak_mobile {
                    font-size: .24rem;
                    background-color: @bg_01;
                }
            }
            .result-input {
                pointer-events: none;
                height: 48px;
                user-select: none;
                background-color: transparent;
                &::placeholder{
                    color: @font_secondary;
                }
                @media @snapeak_mobile {
                    height: 0.78rem;
                }
            }
            &.active {
                border-color: @brand_light;
                box-shadow: none;
            }
            &.error {
                border-color: @error;
            }
            .arrow-icon {
                font-size: 16px;
                color: @brand_light;
                position: absolute;
                top: 50%;
                pointer-events: none;
                transform: translateY(-50%);
                right: 30px;
                font-weight: 500;
                @media @snapeak_mobile {
                    font-size: 0.26rem;
                    right: 0.32rem;
                }
            }
            .required-icon {
                position: absolute;
                color: @error;
                right: -10px;
                font-size: 18px;
                top: 0;
                @media @snapeak_mobile {
                    font-size: 0.32rem;
                    right: -0.15rem;
                }
                @media screen and (max-width: 500px) {
                    right: -0.2rem;
                }
            }
        }
        .drop-down-box {
            background-color: @bg_02;
            border: 1px solid @brand_light;
            border-top: none;
            width: calc(100% - .1rem);
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            left: 0.05rem;
            transform: translate(0, 100%);
            .input-box {
                padding: 0 10px;
                margin-top: 10px;
                position: relative;
                @media @snapeak_mobile {
                    padding: 0 0.04rem;
                }
                input {
                    padding: 0 20px;
                    height: 36px;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
                    background-color: @bg_03;
                    @media @snapeak_mobile {
                        padding: 0 0.36rem;
                        height: 0.76rem;
                    }
                }
                .icon-icon_search-2 {
                    color: #777;
                    font-size: 16px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 24px;
                    pointer-events: none;
                    @media @snapeak_mobile {
                        font-size: 0.28rem;
                        right: 0.24rem;
                    }
                }
            }
            .country-list {
                max-height: 180px;
                width: 100%;
                padding: 0 24px 26px 56px;
                text-align: left;
                box-sizing: border-box;
                overflow-y: auto;
                font-size: 0;
                @media @snapeak_mobile {
                    max-height: 3.08rem;
                    padding: 0.26rem 0.36rem;
                }
                .no-match {
                    margin-top: 26px;
                    margin-right: 30px;
                    display: inline-block;
                    font-size: 16px;
                    .notify-btn {
                        color: @brand_light;
                        cursor: pointer;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                    @media @snapeak_mobile {
                        margin-top: 0;
                        display: block;
                        margin-right: 0;
                        font-size: 0.24rem;
                    }
                }
                .country-item {
                    cursor: pointer;
                    margin-top: 26px;
                    margin-right: 30px;
                    width: 184px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: inline-block;
                    font-size: 0;
                    @media @snapeak_mobile {
                        display: block;
                        margin-top: 0.5rem;
                        margin-right: 0;
                        width: auto;
                        &:nth-of-type(2) {
                            margin-top: 0;
                        }
                    }
                    img {
                        margin-right: 12px;
                        width: 38px;
                        vertical-align: middle;
                        display: inline-block;
                        @media @snapeak_mobile {
                            margin-right: 0.24rem;
                            width: 0.4rem;
                        }
                    }
                    span {
                        font-size: 16px;
                        vertical-align: middle;
                        @media @snapeak_mobile {
                            font-size: 0.26rem;
                        }
                    }
                    &.active,
                    &:hover {
                        span {
                            color: @b_6;
                        }
                    }
                }
            }
        }
    }
    .spinner-clue {
        margin-top: 20px;
        font-size: 14px;
        color: #e74330;
        line-height: 1.2;
        @media @snapeak_mobile {
            margin-top: 0.2rem;
            font-size: 0.24rem;
        }
    }
    .email-subscribe{
        &.dialog.reo-dialog /deep/ .reo-dialog-inner{
            min-height: unset;
        }
        @media @snapeak_mobile{
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            & /deep/ .reo-dialog-inner {
                bottom: unset !important;
                margin: 0 0.3rem !important;
                border-radius: 20px !important;
                width: unset;
                padding-bottom: .24rem;
                .close{
                    right:-0.28rem !important;
                }
            }
        }

    }
}
.country-select-spinner.disabled {
    pointer-events: none;
    .result-box{
        background-color: @bg_01;
        border: 1px solid @fill_disable;
        box-shadow: none;
        input{
            color: @font_disable;
        }
    }
    .top-placeholder{
        background-color: transparent !important;
        color: @font_disable !important;
    }
}
</style>
